module.exports = __webpack_public_path__ + "img/NCRRangerArmor.d95c2b17.gif";